<template>
	<div class="graph-nd graph-1d food-graph">
		<svg :viewBox="'0 0 ' + width + ' ' + height" xmlns="http://www.w3.org/2000/svg">

			<Legend v-bind:width="width"
				v-bind:height="height"
				v-bind:startDate="startDate"
				v-bind:bins="bins.length"
				v-bind:binWidth="binWidth">
			</Legend>

			<!-- Food -->
			<g>
				<g v-for="(bin, index) in foodBins" :key="index"
					class="tooltip-trigger"
					@click="showTooltip(bin, ...arguments)"
					@mouseover="showTooltip(bin, ...arguments)"
					@mouseout="hideTooltip">

					<g v-if="bin.length > 0">
						<rect fill="#fff"
							:x="centerScaleX(index) - 10"
							:y="style.padding"
							:width="20"
							:height="25">
						</rect>
						<!-- <FoodBowelIcon
							:x="centerScaleX(index) - 14"
							:y="height / 2 - 69"
							:width="style.pointRadius * 3"
							:height="style.pointRadius * 3"
							xlink:href="@/assets/icon/icon_bowl.svg">
						</FoodBowelIcon> -->
						<!-- Draw average meal size text S/M/L using a function to average all values in the bin -->
						<text :x="centerScaleX(index) + 1"
							:y="height / 2 - 51"
							:style="{ fill: '#fff', fontSize: 12 }"
							text-anchor="middle">
							{{ binPortionAverage(bin) }}
						</text>
						<!-- Unhealthy -->
						<g v-if="binHealthAverage(bin) == 1">
							<image
								:x="centerScaleX(index) - 3"
								:y="height / 2 - 75"
								:width="8"
								:height="8">
							</image>
						</g>
						<!-- Somewhat Healthy -->
						<g v-if="binHealthAverage(bin) == 2">
							<image v-for="i in [1, 2]" :key="i"
								:x="centerScaleX(index) - (i * 10) + 11"
								:y="height / 2 - 75"
								:width="8"
								:height="8">
							</image>
						</g>
						<!-- Very Healthy -->
						<g v-if="binHealthAverage(bin) == 3">
							<image v-for="i in [1, 2, 3]" :key="i"
								:x="centerScaleX(index) - (i * 10) + 17"
								:y="height / 2 - 75"
								:width="8"
								:height="8">
							</image>
						</g>
					</g>
				</g>
			</g>

			<!-- Beverages -->
			<g>
				<g v-for="(bin, index) in beverageBins" :key="index"
					class="tooltip-trigger"
					@click="showTooltip(bin, ...arguments)"
					@mouseover="showTooltip(bin, ...arguments)"
					@mouseout="hideTooltip">

					<g v-if="bin.length > 0">
						<circle :cx="centerScaleX(index)"
							:cy="height / 2 - 22"
							r="10"
							fill="#ffffff">
						</circle>
						<!-- <FoodBeverageIcon
							:x="centerScaleX(index) - 12.5"
							:y="height / 2 - 15"
							:width="style.pointRadius * 2.5"
							:height="style.pointRadius * 2.5"
							xlink:href="@/assets/icon/icon_glass.svg">
						</FoodBeverageIcon> -->
						<text :x="centerScaleX(index)"
							:y="height / 2 - 20"
							:style="{ fill: '#2D3E4F', fontSize: 10 }"
							text-anchor="middle">
							{{ binTotal(bin) }}
						</text>
						<text :x="centerScaleX(index)"
							:y="height / 2 "
							:style="{ fill: '#ffffff', fontSize: 12 }"
							text-anchor="middle">
							{{ binPortionAverage(bin) }}
						</text>
					</g>

				</g>
			</g>
		</svg>

		<!-- Tooltip -->
		<Tooltip v-bind:display="tooltipDisplay" @hover="hoverTooltip">
			<p v-for="(point, i) in tooltipBin" :key="i">
				<template v-if="point.type == 'food'">
					<strong class="capitalize">{{ point.description }}, {{ formatSizeValue(point.portion) }}, {{ formatHealthValue(point.health) }}</strong><br>
					<small>{{ formatDateTime(point.time) }}</small>
				</template>
				<template v-if="point.type == 'beverage'">
					<strong class="capitalize">{{ point.description }}, {{ formatSizeValue(point.portion) }}</strong><br>
					<small>{{ formatDateTime(point.time) }}</small>
				</template>
			</p>
		</Tooltip>
	</div>
</template>

<script>
import Graph from '.'
import Legend from './component/Legend'

// import FoodBowelIcon from './icon/FoodBowelIcon'
// import FoodBeverageIcon from './icon/FoodBeverageIcon'

export default {
	name: 'food-graph-1d',
	extends: Graph,

	props: {
		precision: {
			type: Number,
			default: 0
		}
	},

	computed: {
		/**
		 * @function 	bins
		 * @desc 		Bins the data points into day-wide bins for the interval determined by the current scale
		 */
		bins() {
			var bins = []

			for (var t = this.startDate.getTime() ; t <= this.date.getTime() ; t += this.binInterval) {
				bins.push(this.data.filter((point) => (t <= point.time && point.time <= t + this.binInterval)))
			}

			return bins
		},

		/**
		 * @function 	foodBins
		 * @desc 		Bins the 'food' data points into day-wide bins for the interval determined by the current scale
		 */
		foodBins() {
			var bins = []

			for (var t = this.startDate.getTime() ; t <= this.date.getTime() ; t += this.binInterval) {
				bins.push(this.data.filter((point) => point.type != 'beverage')
				.filter((point) => (t <= point.time && point.time <= t + this.binInterval)))
			}

			return bins
		},

		/**
		 * @function 	beverageBins
		 * @desc 		Bins the 'beverage' data points into day-wide bins for the interval determined by the current scale
		 */
		beverageBins() {
			var bins = []

			for (var t = this.startDate.getTime() ; t <= this.date.getTime() ; t += this.binInterval) {
				bins.push(this.data.filter((point) => point.type == 'beverage')
				.filter((point) => (t <= point.time && point.time <= t + this.binInterval)))
			}

			return bins
		},

		/**
		 * @function 	legendStart
		 * @desc 		first x-axis point to plot value at
		 */
		legendStart() {
			return this.height - this.style.padding * 2 - this.style.legendHeight
		},
		interval() {
			return this.date.getTime() - this.startDate.getTime()
		},
		binInterval() {
			return this.oneDay * this.binWidth
		}
	},
	methods: {
		setScale(scale) {
			this.scale = scale
		},
		scaleX(x) {
			return x * this.width / this.bins.length
		},
		centerScaleX(x) {
			return (x + 0.5) * this.width / (this.bins.length + 1)
		},
		next() {
			var now = new Date()
			this.date = new Date(this.date.getTime() + this.interval + (this.intevalGap * this.intervalDays))
			if (this.date.getTime() > now.getTime()) {
				this.date = now
			}
		},
		previous() {
			this.date = new Date(this.date.getTime() - this.interval - (this.intevalGap * this.intervalDays))
		},
		binDate(index) {
			return new Date(this.startDate.getTime() + this.binInterval * index)
		},

		/**
		 * @function 	binPortionAverage
		 * @desc 		Returns the ceil of the portion size values of each point in a bin.
		 * @param 		{Array} bin
		 */
		binPortionAverage(bin) {
			if (bin.length == 0)
				return 0
			return this.averageToText(Math.ceil(1.0 * bin.map((point) => point.portion).reduce((a, b) => a + b) / bin.length))
		},

		/**
		 * @function 	binHealthAverage
		 * @desc 		Returns the ceil of the health perception values of each point in a bin.
		 * @param 		{Array} bin
		 */
		binHealthAverage(bin) {
			if (bin.length == 0)
				return 0
			return Math.ceil(1.0 * bin.map((point) => point.health).reduce((a, b) => a + b) / bin.length)
		},
		averageToText(number) {
			if (number == 1)
				return 'S'
			else if (number == 2)
				return 'M'
			else if (number == 3)
				return 'L'
		},

		/**
		 * @function 	binTotal
		 * @desc 		Returns the sum of the values of each point in a bin.
		 * @param 		{Array} bin
		 */
		binTotal(bin) {
			return bin.length
		},

		/**
		 * @function 	withPrecision
		 * @desc 		rounding the given value w.r.t the precision
		 * @param 		{value} Number
		 */
		withPrecision(value) {
			if (this.precision == 0 || Math.abs(value - Math.round(value)) < 0.01) {
				return Math.round(value)
			}
			else {
				return value.toFixed(this.precision)
			}
		},
		formatHealthValue(health_perception) {
			health_perception = parseInt(health_perception)

			if (health_perception === 1)
				return 'not healthy'
			else if (health_perception === 2)
				return 'somewhat healthy'
			else if (health_perception === 3)
				return 'very healthy'
		},
		formatSizeValue(text) {
			text = parseInt(text)

			if (text === 1)
				return 'small'
			else if (text === 2)
				return 'medium'
			else if (text === 3)
				return 'large'
		}
	},
	components: {
		Legend,
		// FoodBowelIcon,
		// FoodBeverageIcon
	}
}
</script>

<style lang="scss" scoped>
</style>
